<template>
  <ApolloMutation
    :mutation="RESET_PASSWORD"
    :variables="{
      token: $route.params.token,
      password: password,
    }"
    @done="done"
  >
    <template v-slot="{ mutate, loading }">
      <v-form @submit="mutate" onSubmit="return false;">
        <v-card-title>{{ $t("resetPassword.resetPassword") }}</v-card-title>
        <input type="text" autocomplete="username" style="display: none" />
        <PasswordCreate
          v-model="password"
          @valid="setDisabled(!$event)"
          :getInProgress="loading"
        />
        <v-btn
          :disabled="disabled || loading"
          :loading="loading"
          color="primary"
          type="submit"
          >{{ $t("forms.submit") }}</v-btn
        >
      </v-form>
    </template>
  </ApolloMutation>
</template>
<script>
import PasswordCreate from "@/components/Auth/PasswordCreate";
import { RESET_PASSWORD } from "@/graphql/AuthMutations";
export default {
  components: {
    PasswordCreate,
  },
  computed: {
    RESET_PASSWORD() {
      return RESET_PASSWORD;
    },
  },
  methods: {
    setDisabled(disabled) {
      this.disabled = disabled;
    },
    done() {
      this.$router.push("token/confirmed");
    },
  },
  data() {
    return {
      password: "",
      disabled: true,
    };
  },
};
</script>
